<!-- 
  Provides a password input field with optional masking

  PROPS:
    icon: Vuetify icon name, e.g. "mdi-exclamation-thick"

    title: Main message title

    detail: Message detail text

    buttonText: Optional button text


  EVENTS:
    @click - Fires when button is clicked
-->

<template>
  <div class="centeredContent">
    <v-card>
      <v-icon class="largeIcon ads-navy" size="110">{{ icon }}</v-icon>
      <h2>{{ title }}</h2>
      <p v-html="detail"></p>
      <v-btn
        v-if="buttonText"
        @click="$emit('click')"
        depressed
        class="primary"
        >{{ buttonText }}</v-btn
      >
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'MessageBox',
  props: {
    icon: {
      default() {
        return 'mdi-exclamation-thick'
      },
      type: String
    },
    title: String,
    detail: String,
    buttonText: String
  }
}
</script>

<style lang="scss">
@import '@/scss/ads.scss';

.centeredContent {
  text-align: center;
  padding: 1em 0;
  > .v-card {
    max-width: 600px !important;
    display: inline-block;
  }

  .largeIcon {
    background-color: $ads-light-blue;
    border-radius: 2em !important;
    padding: 0.2em;
    margin: 0.2em;

    // Prevents width expanding before icon has loaded
    width: 1.4em;
    overflow: hidden;
  }
}
</style>
